import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { FiMonitor, FiTrendingUp, FiServer } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Hero() {
  const { t } = useLanguage();

  const services = [
    { icon: FiMonitor, title: t('hero.col1') },
    { icon: FiTrendingUp, title: t('hero.col2') },
    { icon: FiServer, title: t('hero.col3') },
  ];

  return (
    <section id="home" className="relative pt-40 pb-32 md:pt-52 md:pb-40 bg-brand-dark overflow-hidden">
      {/* Background Gradients */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-4xl mx-auto mb-20">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-8"
          >
            {t('hero.title')}
          </motion.h1>
          <motion.a 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            href="#contact"
            className="inline-block bg-gradient-primary text-white font-semibold px-8 py-4 rounded-full shadow-lg hover:shadow-blue-500/30 transition-all hover:-translate-y-1"
          >
            {t('hero.cta')}
          </motion.a>
        </div>

        {/* 3 Columns Overlapping */}
        <div className="grid md:grid-cols-3 gap-6 transform translate-y-12 md:translate-y-24">
          {services.map((srv, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + (idx * 0.1) }}
              className="bg-white/5 backdrop-blur-lg border border-white/10 p-8 rounded-2xl text-center hover:bg-white/10 transition-colors"
            >
              <div className="w-16 h-16 mx-auto bg-blue-500/20 text-blue-400 rounded-full flex items-center justify-center mb-6">
                <SafeIcon icon={srv.icon} className="text-2xl" />
              </div>
              <h3 className="text-xl font-semibold text-white">{srv.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}